import moment from "moment";
import { AbconetApi } from '../General/AbconetApi';
var formatMoney = require('../General/Helper').formatMoney;
import { isNullOrUndefined } from 'util';
import $ from "jquery";

export class OrderRow extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isDeleting: false
        }
    }

    deleteCart(cartId) {
        this.setState({ isDeleting: true });
        AbconetApi
            .delete('/api/cart/' + cartId + '/delete')
            .then(() => {
                $(document).trigger("CartUpdated");
            });
    }

    approveOrder(cartId) {
        AbconetApi
            .post('/api/cart/' + cartId + '/approve')
            .then(() =>{
                $(document).trigger("CartUpdated");
            });
    }

    setAsCurrent(cartId) {
        var self = this;
        fetch('/api/cart/' + cartId + '/setascurrent', {
                method: 'POST',
                body: JSON.stringify(""),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
            .then(function (response) {
                return response.json();
            })
            .then(function (response) {
                $(document).trigger("CartUpdated", response);
            });
    }

    render() {
        var order = this.props.order;
        var button;
        var viewButton;
        var deleteButton;
        var id = order.salesOrderId;
        var className = "item";
        var isLoading;
        var orderedBy = <div></div>;
        var self = this;

        if (order.cartId != null) {
            className += " item-cart";
            id = order.cartId;

            if (order.isCurrentCart) {
                button = <button className="btn btn-dark float-right disabled">Current</button>;
            } else if (isNullOrUndefined(order.orderApproval) || order.orderApproval.length == 0) {
                button = <button className="btn btn-outline-dark float-right" onClick={() => this.setAsCurrent(order.cartId)}>Set As Current</button>;
            } else if (order.orderedBy != null && !isNullOrUndefined(order.member) && order.member.exoContactId != order.orderedBy.id && order.orderApproval != null && !isNullOrUndefined(order.orderApproval[order.orderApproval.length - 1]) && order.orderApproval[order.orderApproval.length - 1].editDate != null) {
                    button = <button className="btn btn-outline-dark float-right" onClick={() => self.setAsCurrent(order.cartId)}>Set As Current</button>;
            }
            

            if (!order.canApprove) {
                deleteButton = <button className="btn btn-secondary float-right" onClick={() => this.approveOrder(order.cartId)}>Approve Order</button>;
            }


            if (!order.canEdit) {
                deleteButton = <a className="remove" href="#" onClick={() => this.deleteCart(order.cartId)}><i className="icon icon-trash float-right lead"></i></a>;
            }


            viewButton = <a href={`/cart/${order.cartId}/`} className="btn btn-primary float-right">
                View Order
                  </a>;
        } else {
            className += " item-order";
            viewButton = <a href={`/orders/${order.salesOrderId}/`} className="btn btn-primary float-right">
                View Order
                  </a>;
        }

        var name = "";
        if (order.location) {
            name = order.location.name;
        }

        var id = isNullOrUndefined(order.cartId) ? order.salesOrderId : order.cartId;

        var addressLine1;
        if (order.location != null) {
            if (order.location.name != order.location.addressLine1) {
                addressLine1 = order.location.addressLine1;
            } else {
                addressLine1 = order.location.addressLine2;
            }
        }

     
        var orderedBy = null;
        if (order.orderedBy != null) {
            orderedBy = <div className = "created-label" > Ordered By: { order.orderedBy.displayName }</div>
        }

        var loadingDiv = "";
        if (this.state.isDeleting) {
            loadingDiv = <div className="loader-container"><div className="loader"></div></div>;
            deleteButton = null;
        }

        var total = formatMoney(order.totalPrice + order.totalTax);
        if (this.props.hidePrices) {
            total = "";
        }

        return (
            <div className={className}>
                {loadingDiv}
                <div className="row">
                    <div className="col-6">
                        <span className="name-label">{name}</span>
                       
                    </div>
                    <div className="col-3">
                        <div className="item-total">{order.totalLine}</div>
                    </div>
                    <div className="col-3 text-right text-bottom col-total">
                        <strong>{total}</strong>
                        {deleteButton}
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="created-label">Created: {moment(order.createdDateTime).format("DD/MM/YYYY h:mma")}</div>
                        {orderedBy}
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-6">

                        <span className="status"><span className="stockcode">{id}</span>{order.status}</span>

                    </div>
                    <div className="col-12 col-sm-6">

                        {viewButton}
                        {button}
                    </div>
                </div>

                {isLoading}
            </div>
        )
    }

}